var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"availability-app ui-helper-clearfix",attrs:{"id":"js-bookables"}},[_c('BookableItems')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }